interface ScanButtonProps {
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
}

export default function ScanButton({ onClick, disabled = false, loading = false }: ScanButtonProps) {
    return (
        <div className="relative flex items-center justify-center my-8">
            {/* Outer ring animation */}
            <div className="scan-button-ring" />
            <div className="scan-button-ring" style={{ animationDelay: '0.5s', opacity: 0.5 }} />

            {/* Main button */}
            <button
                onClick={onClick}
                disabled={disabled || loading}
                className={`scan-button relative z-10 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
                {loading ? (
                    <div className="animate-spin">
                        <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                    </div>
                ) : (
                    <>
                        <svg className="w-12 h-12 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span className="font-semibold text-lg">SCAN</span>
                    </>
                )}
            </button>
        </div>
    );
}
